module.exports = __webpack_public_path__ + "static/media/Gotham-LightItalic.ab1586df.eot";


//////////////////
// WEBPACK FOOTER
// ./src/theme/fonts/Gotham-LightItalic.eot
// module id = 874
// module chunks = 40